import { cn } from "@/modules/lib/utils"
import { ChronoAmrapRecap } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/chronoAmrapRecap"
import { ChronoEmomRecap } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/chronoEmomRecap"
import { ChronoFortimeRecap } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/chronoFortimeRecap"
import { ChronoTabataRecap } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/chronoTabataRecap"
import {
  type ExerciseFormikType,
  type ExerciseInputKey,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import type { SimpleFormik } from "@/typings/formik"

export function ChronoRecap({
  formik,
  className,
  ...props
}: { formik: SimpleFormik<ExerciseFormikType, ExerciseInputKey> } & React.ComponentProps<"div">) {
  return (
    <div className={cn("mb-2 flex w-full flex-col rounded-2xl bg-surface-foreground px-5 py-6", className)} {...props}>
      {formik.values.chronoAmrap && <ChronoAmrapRecap formik={formik} />}
      {formik.values.chronoEmom && <ChronoEmomRecap formik={formik} />}
      {formik.values.chronoTabata && <ChronoTabataRecap formik={formik} />}
      {formik.values.chronoForTime && <ChronoFortimeRecap formik={formik} />}
    </div>
  )
}
